





















import { useVModel } from '@vueuse/core';
import {
  computed,
  defineComponent,
  PropType,
  ref,
  onMounted
} from '@vue/composition-api';
import { createNamespacedHelpers, useStore } from 'vuex-composition-helpers';
import { IUser } from '@/models';
import {
  IWorkflowFormTemplateState,
  IWorkflowFormTemplateRevisionGetters,
  IWorkflowFormTemplateRevisionActions,
  IWorkflowFormTemplateRevisionMutations
} from '@/store/workflow-form-template';

import { setErrorFromAxiosError } from '@/utils/helpers';

import { IRootState } from '@/store';
import { ISystemError } from '@/models/error/error.types';

import { VAutocomplete } from 'vuetify/lib/components';

export default defineComponent({
  name: 'WorkflowFormTemplateUsersAutoCompletePicker.vue',

  props: {
    value: {
      type: [Array, Number, Object] as PropType<
        IUser | number | (IUser | number)[]
      >
    },

    templateId: { type: Number, required: true },

    errorMessages: {
      type: [String, Array] as PropType<string | string[]>
    },

    outlined: {
      type: Boolean,
      default: true
    }
  },

  setup(props) {
    const userVModel = useVModel(props);

    const store = useStore<IRootState>();

    const { useActions, useGetters } = createNamespacedHelpers<
      IWorkflowFormTemplateState,
      IWorkflowFormTemplateRevisionGetters,
      IWorkflowFormTemplateRevisionActions,
      IWorkflowFormTemplateRevisionMutations
    >(store, 'workflowFormTemplate');

    const { getWorkflowTemplateUsers } = useGetters(['getWorkflowTemplateUsers']);

    const { fetchWorkflowTemplateUsers } = useActions(['fetchWorkflowTemplateUsers']);

    const isLoading = ref(false);

    const error = ref<ISystemError | null>(null);

    const errorMessageList = computed(() => {
      let errorList: string[] = [];

      if (error.value) {
        errorList.push(error.value.message);
      }
      if (props.errorMessages) {
        if (Array.isArray(props.errorMessages)) {
          errorList.push(...props.errorMessages);
        } else {
          errorList.push(props.errorMessages);
        }
      }

      return errorList;
    });

    const templateUsers = computed(() => {
      return getWorkflowTemplateUsers.value;
    });

    onMounted(() => {
      isLoading.value = true;

      fetchWorkflowTemplateUsers(props.templateId)
        .catch((err: any) => {
          error.value = setErrorFromAxiosError(err);
        })
        .finally(() => {
          isLoading.value = false;
        });
    });

    // /** @public */
    const autocompleteRef = ref<
      InstanceType<typeof VAutocomplete> & { reset: () => void }
    >();

    /** @public */
    function reset() {
      if (autocompleteRef.value) autocompleteRef.value.reset();
    }

    return {
      reset,
      autocompleteRef,
      userVModel,
      templateUsers,
      isLoading,
      errorMessageList
    };
  }
});
